'use client';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { useRouter } from '@lib/navigation';
import { Packages } from '@lib/serverPackages';
import { logger } from '@logger';
import { useCheckoutStore } from '@utils/checkout';
import { useUserStore } from '@utils/user';
export default function CheckoutGuard({ packages }: { packages: Packages }) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const checkout = useCheckoutStore();
  const userStore = useUserStore();

  const initCheckout = () => {
    const promo = searchParams.get('promo');
    checkout.setPackages(packages);

    // if on status page, let him be there
    if (window.location.pathname.includes('/premium/dziekujemy') || window.location.pathname.includes('/status')) {
      return;
    }

    if (promo) {
      try {
        checkout.applyPromoCode(promo);
      } catch (e) {
        logger.info(e);
      }
    }
    if (!userStore.isReady) {
      logger.info('Waiting for user...');
      return;
    }

    if (!userStore.isLoggedIn) {
      router.push('/login?from=/premium/checkout');
      return;
    }

    if (userStore.isPremium) {
      router.push('/premium');
      return;
    }

    router.push('/premium/checkout/billing-information');
  };

  useEffect(() => {
    initCheckout();
  }, [userStore.isReady, userStore.isLoggedIn, userStore.isPremium]);

  return null;
}
